<template>
  <div v-if="product.usage_instructions" :class="consumption ? 'product-consumption-block accordion is-active' : 'product-consumption-block accordion'">
    <div class="accordion-header toggle pr-0" @click="consumption = !consumption">
      <p class="has-text-weight-bold">Consumption</p>
      <button class="toggle" aria-label="toggle" >
         <i :class="consumption ? 'text-white fas fa-sort-up' : 'text-white fas fa-sort-down'"></i>
      </button>
    </div>
    <div class="accordion-body">
      <div class="accordion-content">
        <p class="consumption-note" v-if="product" v-html="product.usage_instructions ? product.usage_instructions : 'Not Available.'"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetailConsumption',
  data() {
    return {
      consumption: false,
    };
  },
  props: ['product'],
  methods: {
  },
};
</script>

